<template>
  <div class="form-page-shell" :class="{ 'form-page-shell--wide': wide }">
    <div class="form-page-shell__inner">
      <header v-if="!isEdit" class="form-page-shell__head">
        <h1>{{ title }}</h1>
      </header>

      <section class="form-page-shell__panel">
        <div v-if="isEdit" class="form-page-shell__panel-head">{{ title }}</div>
        <div :class="isEdit ? 'form-page-shell__body form-page-shell__body--edit' : 'form-page-shell__body'">
          <slot />
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormPageShell',
  props: {
    isEdit: { type: Boolean, default: false },
    title: { type: String, required: true },
    subtitle: { type: String, default: '' },
    icon: { type: String, default: 'el-icon-edit-outline' },
    theme: { type: String, default: 'primary' },
    wide: { type: Boolean, default: false }
  }
}
</script>

<style scoped>
.form-page-shell {
  padding: 16px 24px 32px;
}

.form-page-shell__inner {
  max-width: 860px;
  margin: 0 auto;
}

.form-page-shell--wide .form-page-shell__inner {
  max-width: 1180px;
}

.form-page-shell__head {
  margin-bottom: 12px;
}

.form-page-shell__head h1 {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  color: var(--color-text);
}

.form-page-shell__panel {
  border-radius: 8px;
  border: 1px solid var(--color-border);
  background: var(--color-surface);
  box-shadow: var(--shadow-card);
  overflow: hidden;
}

.form-page-shell__panel-head {
  padding: 14px 20px;
  border-bottom: 1px solid var(--color-border-soft);
  font-size: 14px;
  font-weight: 500;
  color: var(--color-text);
}

.form-page-shell__body {
  padding: 22px 24px 26px;
}

.form-page-shell__body--edit {
  padding: 20px 22px 24px;
}

@media (max-width: 768px) {
  .form-page-shell {
    padding: 12px 14px 24px;
  }

  .form-page-shell__body,
  .form-page-shell__body--edit {
    padding: 16px;
  }
}
</style>
